import { Container, Heading, Text, Box, Image } from "@chakra-ui/react";
import { Card, CardHeader, CardBody } from "@chakra-ui/react";
import shield from "../images/Shield.png";
import learn from "../images/Learn.png";
import computer from "../images/Computer.png";

export default function About() {
  return (
    <Box id="about-us">
      <Box className="about-us-container" w={{ sm: "90%", "2xl": "50%" }}>
        <Container>
          <Heading className="about-us-heading">
            Kako SafeCrafts pomaže organizacijama da ostanu bezbedne protiv
            sajber napada
          </Heading>
          <Text className="about-us-text">
            Sa SafeCrafts, organizacije jačaju svoju kulturu bezbednosti i
            motivišu zaposlene da aktivno pomažu u zaštiti svojih organizacija
            od sajber pretnji. E-learning platforma za podizanje svesti o sajber
            bezbednosti lako se implementira i skalira.
          </Text>
        </Container>

        <Box
          className="about-us-card-container"
          display="flex"
          marginBottom="32px"
          gap={{ "2xl": "32px", sm: "16px" }}
          justifyContent="center"
        >
          <Card align="center" className="about-us-card">
            <CardHeader className="about-us-card-image">
              <Image
                src={shield}
                alt="Zastita i bezbednost podataka"
                loading="lazy"
              />
            </CardHeader>
            <CardBody className="about-us-card-body">
              <Text className="about-us-card-text">
                Zaštita podataka i bezbednost podataka: SafeCrafts Avareness
                Platforma obrađuje podatke na način koji je 100% usklađen sa
                GDPR-om. Podaci su uvek sigurni.
              </Text>
            </CardBody>
          </Card>
          <Card align="center" className="about-us-card">
            <CardHeader className="about-us-card-image">
              <Image src={learn} alt="Fokus na ucenje" loading="lazy" />
            </CardHeader>
            <CardBody className="about-us-card-body">
              <Text className="about-us-card-text">
                Fokus na učenje: SafeCrafts Avareness Platform nudi anonimnu
                evaluaciju phishinga i e-učenja. Zaposleni ne moraju da brinu o
                ličnim posledicama.
              </Text>
            </CardBody>
          </Card>
          <Card align="center" className="about-us-card">
            <CardHeader className="about-us-card-image">
              <Image src={computer} alt="Zastita organizacije" loading="lazy" />
            </CardHeader>
            <CardBody className="about-us-card-body">
              <Text className="about-us-card-text">
                Dodata vrednost za sve: SafeCrafts Avareness Training štiti
                organizacije od sajber napada i uči zaposlene šta da rade ako su
                posebno ciljani.
              </Text>
            </CardBody>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
